import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "grid-legend-container" }
const _hoisted_2 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_MilestoneStageStatusItem = _resolveComponent("MilestoneStageStatusItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.tooltipText)
      ? (_openBlock(), _createBlock(_component_ElTooltip, {
          key: 0,
          placement: "top",
          "popper-class": "grid-legend-container__tooltip el-abaca-tooltip"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", {
              textContent: _toDisplayString(_ctx.tooltipText)
            }, null, 8, _hoisted_2)
          ]),
          default: _withCtx(() => [
            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "icon icon-question" }, null, -1))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legend, (el, key) => {
      return (_openBlock(), _createElementBlock("div", { key: key }, [
        _createVNode(_component_MilestoneStageStatusItem, {
          icon: el.icon,
          "icon-size": el.iconSize,
          "is-clickable": false,
          title: el.title
        }, null, 8, ["icon", "icon-size", "title"])
      ]))
    }), 128))
  ]))
}